import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin, Result } from 'antd';
import { canViewDashboard, canViewSoftwareUsage } from '../utils/permissions';

const MANAGE_BANNER_ROLES = ['admin', 'service'];

const AuthLoading = () => (
  <div className="auth-loading-screen">
    <Spin size="large" />
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoading />;
  }

  // 检查用户是否存在且角色为管理员
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'admin') {
    return (
      <div style={{ padding: '24px' }}>
        <Result
          status="403"
          title="403"
          subTitle="抱歉，您没有权限访问此页面。"
        />
      </div>
    );
  }

  return children;
};

export const DashboardRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!canViewDashboard(user)) {
    return (
      <div style={{ padding: '24px' }}>
        <Result
          status="403"
          title="403"
          subTitle="抱歉，仪表盘仅管理员、ngy、十二账号可访问。"
        />
      </div>
    );
  }

  return children;
};

export const SoftwareUsageRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!canViewSoftwareUsage(user)) {
    return (
      <div style={{ padding: '24px' }}>
        <Result status="403" title="403" subTitle="抱歉，您没有权限查看软件使用管理。" />
      </div>
    );
  }
  return children;
};

export const AdminOrServiceRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!MANAGE_BANNER_ROLES.includes(user.role)) {
    return (
      <div style={{ padding: '24px' }}>
        <Result
          status="403"
          title="403"
          subTitle="抱歉，轮播图管理仅管理员和客服账号可访问。"
        />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
